module.exports = __webpack_public_path__ + "static/img/son6_active.55f627e8.png";